import React, { useRef } from 'react';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Avatar } from 'primereact/avatar';
import FlexComponent from './FlexComponent';

// Duplicated per-file, consistent with this codebase's existing convention
// (see Activity.jsx, Members.jsx, etc. — no shared util exists for this).
function getInitials(string) {
    let words = string?.split(' ');
    let initials = words?.map(word => word.charAt(0).toUpperCase());
    return initials?.join('');
}

// Note: `mentions` is populated for both manually-typed "@Name" mentions
// (already rendered inline as a green span by highlightMentionsAndUrls/
// highlightText) and structural mentions (e.g. checklist-send notifications).
// There's no backend flag to distinguish the two, so a typed "@Name" comment
// will show both the inline @mention AND " Name and N others." — accepted,
// known, intentional duplication rather than fragile text-matching.
export default function MentionOthers({ mentions }) {
    const othersOp = useRef(null);

    if (!mentions || mentions.length === 0) {
        return null;
    }

    const [first, ...rest] = mentions;
    const remainingCount = rest.length;

    const handleToggle = (e) => {
        othersOp.current?.toggle(e);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleToggle(e);
        }
    };

    return (
        <>
            {' '}{first?.name}
            {remainingCount > 0 && (
                <>
                    {' and '}
                    <span
                        role="button"
                        tabIndex={0}
                        onClick={handleToggle}
                        onKeyDown={handleKeyDown}
                        style={{ color: '#4a90e2', cursor: 'pointer', textDecoration: 'underline' }}
                    >
                        {remainingCount} {remainingCount === 1 ? 'other' : 'others'}
                    </span>
                    {'.'}
                    <OverlayPanel ref={othersOp} style={{ background: '#254270' }}>
                        <FlexComponent flexDirection="column" gap=".5rem" style={{ minWidth: '180px' }}>
                            {rest.map((m, i) => (
                                <FlexComponent key={m?.id ?? i} justifyContent="start" gap=".5rem">
                                    <Avatar
                                        image={m?.image}
                                        size="small"
                                        shape="circle"
                                        label={getInitials(m?.name)}
                                        style={{ marginRight: '8px' }}
                                    />
                                    <span style={{ color: 'white' }}>{m?.name}</span>
                                </FlexComponent>
                            ))}
                        </FlexComponent>
                    </OverlayPanel>
                </>
            )}
        </>
    );
}
